const config = {
  url: 'https://api.unsplash.com/',
  clientKey: '_3wjJivXiSageh697LP795LuhVzDhFTq-ZPvdylMap4',
};

export default config;
